<script setup lang="ts">
import type { ProductDetail } from '~/types/api'

const props = defineProps<{
  products: ProductDetail[]
  productLineTitle: string | undefined
}>()
</script>

<template>
  <UiSection id="variants" :title="$t('configurator.variants')">
    <div class="overflow-hidden border-y-4 border-neutral-200">
      <div
        class="-mb-1 -mr-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4"
      >
        <ProductSetCard
          v-for="product in props.products"
          :key="product.nid"
          :product="product"
          :product-line-title="props.productLineTitle"
          class="border-b-4 border-r-4 border-neutral-200 p-5"
        />
      </div>
    </div>
  </UiSection>
</template>
